import React from 'react';
import { useLanguage } from '../context/LanguageContext.jsx';
import { useStore } from '../context/StoreContext.jsx';

export function ContactPage() {
  const { language, t } = useLanguage();
  const { storeConfig } = useStore();

  return (
    <div className="container" style={{ maxWidth: '720px', padding: '2rem 1rem' }}>
      <div style={{ backgroundColor: 'var(--color-surface)', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-lg)', padding: '2.5rem' }}>
        <h1 style={{ marginBottom: '1rem' }}>{t('contact')}</h1>
        <p style={{ fontSize: '1.0625rem', marginBottom: '2rem' }}>
          Notre équipe est à votre disposition pour toute question concernant la compatibilité de vos pièces ou le suivi de vos commandes.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.5rem', marginBottom: '2.5rem' }}>
          <div style={{ padding: '1.25rem', backgroundColor: 'var(--color-surface-subtle)', borderRadius: 'var(--radius-md)' }}>
            <span style={{ fontSize: '1.5rem' }}>📞</span>
            <h3 style={{ fontSize: '1rem', marginTop: '0.5rem', marginBottom: '0.25rem' }}>Téléphone</h3>
            <p className="ltr-only font-mono" style={{ fontWeight: 600, color: 'var(--color-primary)' }}>
              {storeConfig.contact.phone}
            </p>
          </div>

          <div style={{ padding: '1.25rem', backgroundColor: 'var(--color-surface-subtle)', borderRadius: 'var(--radius-md)' }}>
            <span style={{ fontSize: '1.5rem' }}>💬</span>
            <h3 style={{ fontSize: '1rem', marginTop: '0.5rem', marginBottom: '0.25rem' }}>WhatsApp Support</h3>
            <p className="ltr-only font-mono" style={{ fontWeight: 600, color: 'var(--color-success)' }}>
              {storeConfig.contact.whatsapp}
            </p>
          </div>

          <div style={{ padding: '1.25rem', backgroundColor: 'var(--color-surface-subtle)', borderRadius: 'var(--radius-md)' }}>
            <span style={{ fontSize: '1.5rem' }}>📍</span>
            <h3 style={{ fontSize: '1rem', marginTop: '0.5rem', marginBottom: '0.25rem' }}>Adresse</h3>
            <p style={{ fontSize: '0.875rem' }}>{storeConfig.contact.address}</p>
          </div>

          <div style={{ padding: '1.25rem', backgroundColor: 'var(--color-surface-subtle)', borderRadius: 'var(--radius-md)' }}>
            <span style={{ fontSize: '1.5rem' }}>⏰</span>
            <h3 style={{ fontSize: '1rem', marginTop: '0.5rem', marginBottom: '0.25rem' }}>Horaires d'ouverture</h3>
            <p style={{ fontSize: '0.875rem' }}>
              {language === 'ar' ? storeConfig.contact.workingHours.ar : storeConfig.contact.workingHours.fr}
            </p>
          </div>
        </div>

        <div style={{ padding: '1.5rem', border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)' }}>
          <h3 style={{ fontSize: '1.125rem', marginBottom: '0.75rem' }}>Besoin d'un renseignement rapide ?</h3>
          <p style={{ fontSize: '0.875rem', marginBottom: '1rem' }}>
            Envoyez la photo de votre carte grise ou de votre véhicule directement sur notre WhatsApp pour une vérification de compatibilité immédiate.
          </p>
          <a
            href={`https://wa.me/${storeConfig.contact.whatsapp.replace(/[^\d]/g, '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
            style={{ backgroundColor: '#25D366', borderColor: '#25D366' }}
          >
            💬 Ouvrir WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
}
